<template>
  <div class="pa-ink-counter-banner-wrapper" ref="wrapperField">
    <div
    class="pa-ink-counter-banner"
    ref="counterBanner"
    @click.prevent="handleClick"
    >{{displayText}}</div>

    <PAInkCounterBannerNewPopper
     :isOpen="isOpenPopper"
     :placement="popperPlacement"
    />
  </div>
</template>

<script>
import PAInkCounterBannerNewPopper from '@/components/Parts/PAInkCounterBanner/PAInkCounterBannerNewPopper.vue'

export default {
  props : {
    textCounting : {
      default: null
    },

    textCountingStartLimit : {
      default: null
    },

    storedInkCount : {
      default: null
    },

    unitLabel : {
      default: '染'
    },

    prefix    : {
      default: '残り約'
    },

    suffix    : {
      default: ''
    },

    separator : {
      default: '/'
    },

    displayStyle : {
      default: 'countingWithLimit' // [countingWithLimit | onlyLimit]
    },

    popperPlacement : {
      default: 'top'
    }
  },

  components : {
    PAInkCounterBannerNewPopper
  },

  data(){
    return {
      displayText       : '',
      isVisiblePopper   : false,
      buttonFieldHeight : 0,

      isOpenPopper      : false,
    };
  },

  computed : {
    isMountedLoginedViewPage(){
      return this.$store.state.layouts.isMountedLoginedViewPage;
    }
  },

  watch : {
    textCounting : {
      handler(value){
        if(typeof value === undefined) return;
        if(value === null) return;

        this.updateDisplayText();
      }
    },

    storedInkCount : {
      handler(value){
        if(typeof value === undefined) return;
        if(value === null) return;

        this.updateDisplayText();
      }
    },

    unitLabel : {
      handler(value){
        if(typeof value === undefined) return;
        if(value === null) return;

        this.updateDisplayText();
      }
    },

    isMountedLoginedViewPage : {
      handler(value){
        if(value === false) return;

        this.initializeOffsetHeight();
      }
    }
  },

  methods : {
    handleClick(){
      this.isVisiblePopper = !this.isVisiblePopper;
      
      this.isOpenPopper = !this.isOpenPopper;
    },

    updateDisplayText(){
      if( (this.textCounting === null) || (this.storedInkCount === null) ){
        this.setDisplayTextInitial();
      }else{
        this.setDisplayTextCounter();
      }
    },

    setDisplayTextCounter(){
      let counterText = '';

      let currentCountingNumber = 0;

      if(this.textCountingStartLimit !== null){
        if(this.textCountingStartLimit > this.textCounting){
          currentCountingNumber = 0;
        }else{
          currentCountingNumber = (this.textCounting - this.textCountingStartLimit);
        }
      }else{
        currentCountingNumber = this.textCounting;
      }

      switch(this.displayStyle){
        case 'countingWithLimit':
          counterText = this.$options.filters.mutateFullWidth(currentCountingNumber);
          counterText += this.separator;
          counterText += this.$options.filters.mutateFullWidth(this.storedInkCount);
          counterText += this.unitLabel;
        break;

        case 'onlyLimit':
          counterText = this.$options.filters.mutateFullWidth(this.storedInkCount);
          counterText += this.unitLabel;
        break;

        case 'showEstimateRemaining':
          counterText  = (this.storedInkCount - currentCountingNumber);
          counterText  = this.$options.filters.mutateFullWidth(counterText);
          counterText += this.unitLabel;

          counterText = this.prefix + counterText;
        break;
      }

      this.displayText = counterText;
    },

    setDisplayTextInitial(){
      this.displayText = '----' + this.unitLabel;
    },

    initializeOffsetHeight(){
      this.buttonFieldHeight = this.$refs.wrapperField.offsetHeight;
    }
  },

  mounted(){
    this.displayText = '----' + this.unitLabel;

    this.initializeOffsetHeight();
  }
}
</script>

<style lang="scss">
.pa-ink-counter-banner-wrapper{
  position: relative;

  .pa-ink-counter-banner{
    font-size: 13px;
    line-height: 19px;
    background-color: rgba(189, 181, 181, 0.5);
    color:#7e7972;
    border-radius: 6px;
    height:22px;
    padding:2px 8px 2px 6px;
    margin-top:5px;
    margin-left:6px;
    text-align: center;
    user-select: none;

    &-simple{
      background-color: inherit;
      color:inherit;
      margin:0;
      padding:0;
      height: inherit;
      margin-right: 0.5rem;
      font-size: 1.1rem;
      line-height: 2.4;
      border-radius: inherit;
    }
  }
}
</style>